import MultipleChoiceQuestionTemplate from '~/pages/anatomyV2/libs/components/MultipleChoiceQuestionTemplate'
import { MULTIPLE_CHOICE_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/multipleChoiceCorrectAnswers'
import {
  kidneysPNG,
  kidneysWEBP,
  liverPNG,
  liverWEBP,
  skinPNG,
  skinWEBP,
  stomachPNG,
  stomachWEBP,
} from '~/pages/anatomyV2/organRegenerates/constants'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 3

const OPTIONS = [
  {
    key: 'liver',
    i18nKey: 'onboarding.organRegenerates.options.liver',
    png: liverPNG,
    webp: liverWEBP,
  },
  {
    key: 'skin',
    i18nKey: 'onboarding.organRegenerates.options.skin',
    png: skinPNG,
    webp: skinWEBP,
  },
  {
    key: 'kidneys',
    i18nKey: 'onboarding.organRegenerates.options.kidneys',
    png: kidneysPNG,
    webp: kidneysWEBP,
  },
  {
    key: 'stomach',
    i18nKey: 'onboarding.organRegenerates.options.stomach',
    png: stomachPNG,
    webp: stomachWEBP,
  },
]

const OrganRegeneratesAnatomyV2 = (props: TPageProps) => (
  <MultipleChoiceQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.organRegenerates.title"
    options={OPTIONS}
    correctOptionKey={
      MULTIPLE_CHOICE_CORRECT_ANSWERS[PageId.ORGAN_REGENERATES_ANATOMY_V2_1]!
    }
    correctExplanationI18nKey="onboarding.organRegenerates.correctExplanation"
    incorrectTitleI18nKey="onboarding.organRegenerates.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.organRegenerates.incorrectExplanation"
    question="Organ that fully regenerates"
  />
)

export default OrganRegeneratesAnatomyV2
